const items = [
	{
		id: 1,
		name: "appType.slideShow",
		key: "appType.slideShow",
	},
	{
		id: 2,
		name: "appType.promotion",
		key: "appType.promotion",
	},
	{
		id: 3,
		name: "appType.announce",
		key: "appType.announce",
	}
];

export default items;